export default __webpack_public_path__ + "icon_support.1c031effd63de5acdf1c49a2165a451c.svg";